import { render } from "./section-baner.vue?vue&type=template&id=5da0a59a"
import script from "./section-baner.vue?vue&type=script&lang=js"
export * from "./section-baner.vue?vue&type=script&lang=js"

import "./section-baner.vue?vue&type=style&index=0&id=5da0a59a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__